import type { HTMLAttributes, Ref } from 'react';

import { RovingIndexContainer } from '../../components';
import { useClassName, useFocusFirst, useMergedRef } from '../../hooks';

import { NavItem } from './nav-item';
import styles from './nav-items.module.scss';
import { NavSubmenu } from './nav-submenu';


export type Props = HTMLAttributes<HTMLUListElement> & {
  ref?: Ref<HTMLUListElement>;
  pages: readonly Queries.Squidex_Pages[];
  isEnabled: boolean;
  level?: number;
};

export const NavItems = ({
  pages,
  isEnabled,
  level = 1,
  className,
  ref,
  ...navItems
}: Props) => {
  const parentRef = useMergedRef(ref);
  const wrapperClassName = useClassName([
    styles.wrapper,
    styles[`level${level}`],
    className,
  ]);

  useFocusFirst(parentRef, level > 1 && isEnabled);

  return (
    <RovingIndexContainer isEnabled={isEnabled} ref={parentRef}>
      {(rovingContainer) => (
        <ul {...navItems} {...rovingContainer} className={wrapperClassName}>
          {pages.map((page) => (
            <li role="none" className={styles.item} key={page.flatData.alias}>
              {page.referencingPagesContents?.length ? (
                <NavSubmenu
                  parent={page}
                  level={level + 1}
                  pages={page.referencingPagesContents}
                />
              ) : (
                <NavItem page={page} level={level} />
              )}
            </li>
          ))}
        </ul>
      )}
    </RovingIndexContainer>
  );
};
